module.exports = __webpack_public_path__ + "img/planet-happy.6ce394e8.svg";